import type { ButtonHTMLAttributes } from 'react';

type Tone = 'accent' | 'tonal' | 'neutral' | 'danger' | 'violet';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  tone?: Tone;
  size?: 'md' | 'sm';
};

/** Filled buttons only (wave 10 spec §1): there is no outline-only variant. */
export function Button({ tone = 'accent', size = 'md', className = '', ...rest }: Props) {
  const classes = ['btn', `btn-${tone}`, size === 'sm' ? 'btn-sm' : '', className].filter(Boolean).join(' ');
  return <button className={classes} {...rest} />;
}
